import { render, staticRenderFns } from "./OpenBlindBoxRecord.vue?vue&type=template&id=41a67f98&scoped=true"
import script from "./OpenBlindBoxRecord.vue?vue&type=script&lang=js"
export * from "./OpenBlindBoxRecord.vue?vue&type=script&lang=js"
import style0 from "./OpenBlindBoxRecord.vue?vue&type=style&index=0&id=41a67f98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a67f98",
  null
  
)

export default component.exports